export const assignablePermissionTypes = {
  ArchiveAdmin: 'ArchiveAdmin',
  Batch: 'BatchProvMenu',
  BegBalAdmin: 'BegBalAdmin',
  ChartAdmin: 'ChartAdmin',
  CommAdmin: 'CommAdmin',
  ConvRateAdmin: 'ConvRateAdmin',
  Monitor: 'AppAdminMenu',
  ObligationAdmin: 'ObligationAdmin',
  RestrictedObligationsAdmin: 'RestrictedObligationsAdmin',
  SLMenuAddBatch: 'BSMMenuAddBatch',
  SLMenuBegBal: 'SLMenuBegBal',
  SLRateChange: 'BSMRateChange',
  SubledgerView: 'BSMView',
  TLSAccountAdmin: 'TLSAccountAdmin',
  UserAdmin: 'UserAdmin',
  RateAdmin: 'RateAdmin',
  BooktoTaxDifferencesAdmin: 'BooktoTaxDifferencesAdmin',
  TrialBalanceThresholdAdmin: 'TrialBalanceThresholdAdmin',
  ScenarioEditor: 'ScenarioEditor',
  ProformaCalculation: 'ProformaCalculation',
  BypassClientLock: 'BypassClientLock',
  BSMAllowUnlinkNetGross: 'BSMAllowUnlinkNetGross',
  RTPMenu: 'RTPMenu',
  UserExpiration: 'UserExpiration',
  E2EHealthcheck: 'E2EHealthcheck',
} as const;

export type AssignablePermissionType = typeof assignablePermissionTypes[keyof typeof assignablePermissionTypes];
